// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-cascader.container-load-type-cascader {\n  width: 100%;\n}\n.el-cascader.container-load-type-cascader .el-cascader__tags .custom-display {\n    overflow: hidden;\n    white-space: nowrap;\n    padding-left: 15px;\n}\n.el-cascader.container-load-type-cascader .el-cascader__tags .el-tag--info {\n    display: none;\n}\n", ""]);
// Exports
module.exports = exports;
